import gql from 'graphql-tag'

export const fetchContact = contact_id => {
	return {
		query: gql`
			query ($contact_id: bigint!) {
				contact: contacts_by_pk(id: $contact_id) {
					category_id
					contacts_organizations {
						id: organization_id
					}
					email
					image_id
					name
					order
					phone
					position
				}
			}
		`,
		variables: { contact_id }
	}
}
